<template>
  <div class="conversation">
    <div v-if="membersExceptSelf.length > 0" class="active-member-list">
      <active-member v-for="member in membersExceptSelf" avatar
        v-bind:name="member.name"
        v-bind:key="member.id"
        v-bind:conversationId="conversationId"
        v-bind:memberId="member.id">
      </active-member>
    </div>
    <div v-else class="share-link-hint">
        <p>⇡</p>
        <p>No one here yet – share the link!</p>
        <p>⇣</p>
        <a v-bind:href="'https://chnt.app/join/' + conversationId">{{'chnt.app/join/' + conversationId}}</a>
    </div>
    <input-area v-bind:conversationId="conversationId" v-bind:memberId="memberId"></input-area>
  </div>
</template>

<script>
import { db } from '../db'
import ActiveMember from './ActiveMember'
import InputArea from './InputArea'

export default {
  name: 'Conversation',

  props: {
      conversationId: String
  },

  components: {
    ActiveMember,
    InputArea
  },

  data() {
    return {
    members: [],
    memberId: null
    }
  },

  computed: {
    membersExceptSelf() {
        return this.members.filter(member => member.id !== this.memberId);
    }
  },

  beforeMount() {
    //TODO refactor memberId access and storage
    const conversationMap = JSON.parse(localStorage.conversationMap);
    this.memberId = conversationMap[this.conversationId];
  },

  watch: {
      conversationId: {
          immediate: true,
          handler(conversationId) {
              this.$bind('members', db.collection('conversations').doc(conversationId).collection('members'))
          }
      }
  }
}
</script>

<style scoped>
.active-member-list {
    padding-top: 10px;
}
.share-link-hint {
    text-align: center;
    color: #6d547e;
}
p:first-child {
    margin-top: 0;
}
a {
    color: #6d547e;
    font-size: 20px;
}
</style>
